import { Box, Divider, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { RiUserLine } from '@remixicon/react';
import { useNavigate } from '@tanstack/react-router';
import { useAuth } from 'src/auth';
import { AgButton, AgText } from 'src/components/ui';
import useAnchorEl from 'src/hooks/useAnchorEl';
import { appLinks } from 'src/routing/appLinks';
import { DropdownMenuItem } from '../DropdownMenuItem';

export function UserMenu() {
  const navigate = useNavigate();
  const { currentUser, logOut } = useAuth();
  const { ref, anchorEl, open, handleOpen, handleClose } = useAnchorEl();

  return (
    <div>
      <AgButton
        ref={ref}
        id="basic-button"
        variant="ghost"
        size="icon-md"
        shape="circle"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onPress={handleOpen}
        className="p-0"
      >
        <div className="center bg-orange-bg text-orange-text h-8 w-8 text-14 rounded-full">
          {currentUser.firstName?.charAt(0)}
          {currentUser.lastName?.charAt(0)}
        </div>
      </AgButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography>{`${currentUser.firstName ?? ''} ${currentUser.lastName ?? ''}`.trim()}</Typography>
          <AgText size="14">{currentUser.emailAddress ?? currentUser.emailAddresses?.[0].emailAddress}</AgText>
        </Box>
        <Divider />
        <Box sx={{ py: 1 }}>
          <DropdownMenuItem
            Icon={RiUserLine}
            onClick={() => {
              void navigate(appLinks.userProfile());
              handleClose();
            }}
            label="Profile"
          />
        </Box>
        <Divider></Divider>
        <MenuItem
          onClick={() => {
            handleClose();
            logOut({ redirectTo: '/login' });
          }}
        >
          LOG OUT
        </MenuItem>
      </Menu>
    </div>
  );
}
